/**
 * PlayerPreviewSection — titled block used by every player preview drawer
 * section (SE-5494).
 * @module features/player-kanban/components/molecules/PlayerPreviewSection
 */

export { default } from "./PlayerPreviewSectionView";
export type { PlayerPreviewSectionViewProps } from "./PlayerPreviewSectionView";
